export enum ApplicationIdamRegisterEventTypeEnum {
  signUp = 'signUp',
  signUpError = 'signUpError',
}
